export const isActiveStyles =
  " text-2xl text-green-800 font-semibold hover:text-green-700 px-4 py-2 duration-100 transition-all ease-in-out";

export const isNotActiveStyles =
  " text-xl text-textColor hover:text-green-700 duration-100 px-4 py-2 transition-all ease-in-out";

export const statuses = [
  { id: 1, title: "Seasonal", category: "Seasonal" },
  { id: 2, title: "Leafy", category: "Leafy" },
  { id: 3, title: "Fruits", category: "fruits" },
  { id: 4, title: "Roots", category: "roots" },
  { id: 5, title: "Citrus", category: "citrus" },
  { id: 6, title: "Exotic", category: "exotic" },
  { id: 7, title: "Herbs", category: "herbs" },
];

export const randomData = [
  {
    id: 1,
    imageURL:
      "https://firebasestorage.googleapis.com/v0/b/food-app-nov-22.appspot.com/o/Pictures%2F1674704862591_dessert2.png?alt=media&token=7c001521-f0ac-40a8-b07a-42dc4aab444a",
    product_name: "Iceream",
    product_category: "Chocolate & vanilla",
    product_price: "23.00",
  },
  {
    id: 2,
    imageURL:
      "https://firebasestorage.googleapis.com/v0/b/food-app-nov-22.appspot.com/o/Pictures%2F1674797445483_f1.png?alt=media&token=8b46c1ce-9600-4f9a-8ff7-3518b1bf6db3",
    product_name: "Strawberries",
    product_category: "Fresh Strawberries",
    product_price: "18.00",
  },
  {
    id: 3,
    imageURL:
      "https://firebasestorage.googleapis.com/v0/b/food-app-nov-22.appspot.com/o/Pictures%2F1674797463817_f2.png?alt=media&token=69ab9301-ef04-4690-bc68-e537cdc1985e",
    product_name: "Pine Apple",
    product_category: "Juicy Apples",
    product_price: "16.00",
  },
  {
    id: 4,
    imageURL:
      "https://firebasestorage.googleapis.com/v0/b/food-app-nov-22.appspot.com/o/Pictures%2F1674797033037_c3.png?alt=media&token=7644719f-95ae-42f2-8227-3fb843faa567",
    product_name: "Chicken Kebab",
    product_category: "Mixed Kebab Plate",
    product_price: "22.0",
  },
  {
    id: 5,
    imageURL:
      "https://firebasestorage.googleapis.com/v0/b/food-app-nov-22.appspot.com/o/Pictures%2F1674797376326_d4.png?alt=media&token=7d37b12c-f3a8-4561-974e-de6574ddfea6",
    product_name: "Mojito",
    product_category: "Cocktail Drinks",
    product_price: "10.0",
  },
  {
    id: 6,
    imageURL:
      "https://firebasestorage.googleapis.com/v0/b/food-app-nov-22.appspot.com/o/Pictures%2F1674797198643_cu3.png?alt=media&token=e630d851-91aa-4135-a241-0ab961a7c4ee",
    product_name: "Prawn Masala",
    product_category: "Spicy Masala",
    product_price: "20.0",
  },
];
